// Class: motion.easing._Cubic.CubicEaseIn

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var CubicEaseIn = function() {
}

// Meta

CubicEaseIn.__name__ = ["motion","easing","_Cubic","CubicEaseIn"];
CubicEaseIn.__isInterface__ = false;
CubicEaseIn.__interfaces__ = [(motion_easing_IEasing().default)];
CubicEaseIn.prototype = {
	calculate: function(k) {
		return k * k * k;
	},
	ease: function(t,b,c,d) {
		return c * (t /= d) * t * t + b;
	}
};
CubicEaseIn.prototype.__class__ = CubicEaseIn.prototype.constructor = $hxClasses["motion.easing._Cubic.CubicEaseIn"] = CubicEaseIn;

// Init



// Statics




// Export

exports.default = CubicEaseIn;